import Base from "../Base";
import Organization from "./Organization";

export default class Organizations extends Base {
  async get(id) {
    return new Organization(this._api, await this._api.get(`/organizations/${ id }/`));
  }
}
